/**
 * Custom Klaviyo tracking
 */

const initWishlistTrackingEvents = () => {
  const selector = '[data-product-handle]';

  document.addEventListener('click', (e) => {
    e.stopPropagation();
    if (klaviyo == undefined || !klaviyo) return;

    const target = e.target;
    const { productHandle } = target.dataset;

    if (productHandle) {
      const isInWishlist = localStorage.getItem('shopify-wishlist')?.split(',').includes(productHandle);
      const eventName = isInWishlist ? 'Remove from wishlist' : 'Add to wishlist';
      const item = {
        'ProductName': productHandle,
      };
      
      klaviyo.push(['track', eventName, item]);
    }
  });
};

document.addEventListener('DOMContentLoaded', function() {
  initWishlistTrackingEvents();
});